import * as React from 'react';

import { Alert, AlertSize, AlertType } from '../../components/Alert/Alert';
import { Bem } from '../../service/Bem/Bem';
import { isVideoAddition } from '../common/helpers';
import { CommonPresets } from '../CommonPresets/CommonPresets';
import { VideoPresets } from '../VideoPresets/VideoPresets';

import { PresetsProps } from './typings';

const BLOCK = 'canvas-presets';

export class Presets extends React.PureComponent<PresetsProps> {
    componentDidMount(): void {
        this.props.loadPresets();
    }

    render() {
        return (
            <>
                {this.props.error && (
                    <Alert size={AlertSize.s} className={Bem.cls(BLOCK, 'error')} type={AlertType.error}>
                        <div>{this.props.error.text}</div>
                    </Alert>
                )}

                {isVideoAddition(this.props.creativeType) ? (
                    <VideoPresets dataProvider={this.props.dataProvider} selectPreset={this.props.selectPreset} />
                ) : (
                    <CommonPresets dataProvider={this.props.dataProvider} selectPreset={this.props.selectPreset} />
                )}
            </>
        );
    }
}
